import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { FreightPayersService } from "./freight-payers.service";
import { switchMap, map, catchError, of } from "rxjs";
import { loadFreightPayers, loadFreightPayersFailure, loadFreightPayersSuccess } from "./freight-payer.actions";

@Injectable()
export class FreightPayerEffects {
    constructor(private actions$: Actions, private freightPayerService: FreightPayersService) { }

    loadFreightPayers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadFreightPayers),
            switchMap(() =>
                this.freightPayerService.search().pipe(
                    map((freightPayers) => loadFreightPayersSuccess({ freightPayers })),
                    catchError((error) => of(loadFreightPayersFailure({ error: error.message })))
                )
            )
        )
    );
}